<template>
  <div class="overflow-hidden h-100 w-100 p-3">
    <div class="position-relative h-100 w-100" id="canvas-container-main">
      <canvas id="job-canvas"></canvas>
      <canvas id="cursor"></canvas>
    </div>
  </div>
</template>
<script>
import store from './../../mixins/store.mixin'
import currentJob from './../../mixins/current_job.mixin'
import {fabric} from "fabric";
import {EventBus} from "../../events/event.bus";
import {axiosWrapper} from "../../../../../../../lib/axios-wrapper/axios-wrapper";
import {globalLogger} from "../../../../../../helper/global-logger";

async function encodeImageToBase64(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      resolve(reader.result.split(',')[1]);
    };
    reader.onerror = () => {
      reject(new Error('Error reading image'));
    };
    reader.readAsDataURL(blob);
  });
}

async function encodeImageToBase64Url(imageUrl) {
  try {
    const response = await axiosWrapper.get(imageUrl, {}, {responseType: 'blob'});
    const blob = await response.data;
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        resolve(reader.result.split(',')[1]);
      };
      reader.onerror = () => {
        reject(new Error('Error reading image'));
      };
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    globalLogger.log('base64 - encodeImageToBase64 - error encoding image to base64', error);
    return null;
  }
}

function decodeBase64ToImageUrl(base64String, mimeType) {
  return `data:${mimeType || 'image/png'};base64,${base64String}`;
}

export default {
  name: "JobCanvas",
  props: {},
  components: {},
  mixins: [
    store,
    currentJob,
  ],
  data() {
    return {
      canvas: null,
      background: ''
    };
  },
  mounted: function () {
    this.canvas = new fabric.Canvas('job-canvas', {
      backgroundImage: this.currentJob.apiJob.output[0].uri,
      isDrawingMode: true,
      width: 1024,
      height: 1024
    });

    this.canvas.freeDrawingBrush.width = 50;
    this.canvas.freeDrawingBrush.color = 'black';
    /*
        let cursor = new fabric.StaticCanvas("cursor", {
            width:1024,
            height:1024
        });

        let cursorOpacity = .5;
        window.mousecursor = new fabric.Circle({
          left: -100,
          top: -100,
          radius: this.canvas.freeDrawingBrush.width / 2,
          fill: "rgba(0,0,255," + cursorOpacity + ")",
          stroke: "none",
          originX: 'center',
          originY: 'center'
        });

        this.canvas.on('mouse:move', function (evt) {
          let mouse = this.getPointer(evt.e);
          window.mousecursor
              .set({
                top: mouse.y,
                left: mouse.x
              })
              .setCoords()
              .canvas.renderAll();
        });

        this.canvas.on('mouse:out', function () {
          // put circle off screen
          window.mousecursor
              .set({
                left: -100,
                top: -100,
              })
              .setCoords()
              .canvas.renderAll();
        });

        //this.canvas.deactivateAll().renderAll();
        cursor.add(window.mousecursor);
    */

    //window.addEventListener('resize', resizeCanvas, false);

    let that = this;

    function resizeCanvas() {
      that.canvas.setDimensions({width: 1024, height: 1024});
      cursor.setDimensions({width: 1024, height: 1024});
      return;
      that.canvas.setHeight(document.getElementById('canvas-container-main').offsetHeight);
      that.canvas.setWidth(document.getElementById('canvas-container-main').offsetWidth);
      cursor.setHeight(document.getElementById('canvas-container-main').offsetHeight);
      cursor.setWidth(document.getElementById('canvas-container-main').offsetWidth);
      that.canvas.renderAll();
    }

    // resize on init
    //resizeCanvas();

    /*
        this.canvas.backgroundColor = 'yellow';

        fabric.Image.fromURL(this.currentJob.apiJob.output[0].uri, function(myImg) {
          //i create an extra let for to change some image properties
          let img1 = myImg.set({ left: 0, top: 0 ,width:150,height:150});
          this.canvas.add(img1);
        });

     */
  },
  created: function () {
    EventBus.$on('export', (data) => {
      this.exportImage();
    });
    EventBus.$on('clearMask', (data) => {
      this.clearMask();
    });

    this.startBG();
  },
  methods: {
    async startBG() {
      let baseImage = await encodeImageToBase64Url(this.currentJob.apiJob.output[0].uri);
      this.resultPage.image = decodeBase64ToImageUrl(baseImage, 'image/png');
      let that = this;
      fabric.Image.fromURL(this.currentJob.apiJob.output[0].uri, function (img) {
        that.background = img;
      });
    },
    clearMask() {
      this.canvas.clear();
      this.canvas.setBackgroundImage(this.background, this.canvas.renderAll.bind(this.canvas));
    },
    async exportImage() {
      this.canvas.setBackgroundImage(null);
      const svg = this.canvas.toSVG();
      const a = document.createElement("a");
      const blob = new Blob([svg], {type: "image/svg+xml"});
      const blobURL = URL.createObjectURL(blob);

      let image = await encodeImageToBase64(blob);
      let base64Image = this.canvas.toDataURL({
        width: this.canvas.width,
        height: this.canvas.height,
        left: 0,
        top: 0,
        format: 'png',
      });

      this.resultPage.mask = base64Image;


    }
  },
  computed: {}
};
</script>
<style lang="scss" scoped>
#job-canvas {
}

canvas, .canvas-container {
  position: absolute !important;
  left: 0 !important;
  top: 0 !important;
  width: 100% !important;
  height: 100% !important;
}

#cursor {
  pointer-events: none !important;
}
</style>
